import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class WarningRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      value, data, tooltip,
    } = this.props;
    if (!data) {
      return null;
    }
    const emptyProductTooltip = (
      <Tooltip id={`empty-product-tip-${data._id}`}>
        <div>{tooltip}</div>
      </Tooltip>
    );
    return (
      <OverlayTrigger placement="top" overlay={emptyProductTooltip}>
        <span>
          <Fa name="exclamation-triangle" />
          {' '}
          {value}
        </span>
      </OverlayTrigger>
    );
  }
}

WarningRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
  }),
  tooltip: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
WarningRenderer.defaultProps = {
  data: null,
  value: null,
  tooltip: null,
};

export default WarningRenderer;
